$(document).ready(function(){
  ////

  // http://www.cosmosoft.fr/cosmoAPI/passerelle/Passerelle-test-.xml
  // http://www.cosmosoft.fr/cosmoAPI/passerelle/passerelle2.php?xi=Mzg3ejo2T0U0ODY4Yjp0ZXN0OmRlZmF1bHRfZW5j

  var inc = $(window).height()/2;
  var size = ''

  function detectmob() {
    if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ){
      return true;
    }
    else {
      return false;
    }
  }

  var detectmob = detectmob();

  if($(window).width() > 920){

    $('.item img').each(function(){
      $(this).resizeToParent();
    })
    size = 'desktop'
  }else{
    size = 'mobile'
  }


  $(window).resize(function(){
    if($(window).width() > 920 && size === 'mobile'){
      size = 'desktop'
      $('.item img').each(function(){
        $(this).resizeToParent();
      })

    }else if($(window).width() <= 920 && size === 'desktop'){
      size = 'mobile'
      $('.item img').each(function(){
        $(this).attr('style','');
        var parent = $(this).parent();
        $( this ).clone().prependTo(parent);
        $(this).remove();
      })

    }

  })


  $(window).scroll( function(){

    /* Check the location of each desired element */
    $('.fade').each( function(i){

        var bottomElt = $(this).offset().top + $(this).outerHeight();
        var bottomWindow = $(window).scrollTop() + $(window).height();

        /* If the object is completely visible in the window, fade it it */
        if(!detectmob){
          if( bottomWindow+inc > bottomElt ){

              $(this).addClass('show');

          }
        }else{

          if( $(window).scrollTop()+inc > $(this).offset().top ){

              $(this).addClass('show');

          }

        }

    });

  });

})



// WEBPACK FOOTER //
// ./src/js/accueil.js